import React from 'react';
import { Container, Paper, Typography, Box, Button, Chip } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { Link as RouterLink } from 'react-router-dom';

export default function ClientHomePage() {
  return (
    <Container maxWidth="md" sx={{ py: 8, flex: 1 }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 4, md: 6 },
          borderRadius: 4,
          border: '1px solid #D6CEC4',
          bgcolor: '#fff',
          textAlign: 'center',
          boxShadow: '0 20px 40px rgba(95, 75, 59, 0.08)',
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Chip
            icon={<VerifiedUserIcon style={{ color: '#10b981' }} />}
            label="CLIENT Subdomain Portal"
            sx={{ bgcolor: 'rgba(16, 185, 129, 0.1)', color: '#10b981', fontWeight: 700, px: 1, py: 2 }}
          />
        </Box>

        <Typography variant="h3" sx={{ fontWeight: 800, color: 'text.primary', mb: 2 }}>
          Welcome to Client Portal!
        </Typography>

        <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 600, mb: 3 }}>
          client.sourceseas.com
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto', mb: 4, fontSize: '1.1rem', lineHeight: 1.7 }}>
          You have successfully logged in to the official Client / Buyer Subdomain Portal. Manage enquiries, sample requests, and orders. Your active session is verified across the core Sourceseas & Trade Expert ecosystem.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            size="large"
            component={RouterLink}
            to="/profile"
            startIcon={<ShoppingBagIcon />}
            sx={{
              py: 1.5,
              px: 4,
              borderRadius: 3,
              textTransform: 'none',
              fontWeight: 700,
              fontSize: '16px',
              bgcolor: 'primary.main',
              '&:hover': { bgcolor: 'primary.dark' },
            }}
          >
            View My Profile Details
          </Button>

          <Button
            variant="outlined"
            size="large"
            href={process.env.REACT_APP_REDIRECT_URL}
            sx={{
              py: 1.5,
              px: 4,
              borderRadius: 3,
              textTransform: 'none',
              fontWeight: 700,
              fontSize: '16px',
              borderColor: 'secondary.main',
              color: 'secondary.main',
              '&:hover': { borderColor: 'secondary.dark', bgcolor: 'rgba(95, 75, 59, 0.05)' },
            }}
          >
            Return to Sourceseas Main Portal
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
